import { api } from '../../../index';
import { PaywallMeta } from '../../../types/paywall';
import { DiscoveryDoneResponse } from '../../types/UserDiscoveryResponse.types';
import {
  CreatePaymentEntityParams,
  CreatePaymentEntityResponse,
  DefaultCouponCodeResponse,
  FinalizePaymentAfterRedirectionParams,
  PayPalClientIdResponse,
  PayPalPlansResponse,
  ProcessPaymentResponse,
  StripePlansResponse,
  StripeSecretOnlyResponse,
} from '../../types/useUserPayment.type';
import { PaymentData, PayPalData } from '../../UserPayment';

export const getStripePlans = async (): Promise<StripePlansResponse> => {
  return await api.get<StripePlansResponse>('payment/stripe/voices-purchase/plans');
};

export const getStripeSecretOnly = async (): Promise<StripeSecretOnlyResponse> => {
  return await api.get<StripeSecretOnlyResponse>('payment/stripe/voices-purchase/only-secret');
};

export const getPayPalClientId = async (): Promise<PayPalClientIdResponse> => {
  return await api.get<PayPalClientIdResponse>('/configurations/desktop');
};

export const getPayPalPlans = async (): Promise<PayPalPlansResponse> => {
  return await api.get<PayPalPlansResponse>('/payment/paypal/plans');
};

export const processPayment = async (data: PaymentData): Promise<ProcessPaymentResponse> => {
  return await api.post<ProcessPaymentResponse>('payment/stripe', data);
};

export const payPalSubscription = async (data: PayPalData): Promise<any> => {
  return await api.post<any>('payment/paypal/subscriptions', data);
};

export const getDefaultCouponCode = async (): Promise<DefaultCouponCodeResponse> => {
  return await api.get<DefaultCouponCodeResponse>('payment/default-coupon-code');
};
export const getDiscountFromCoupon = async (coupon: string): Promise<DefaultCouponCodeResponse> => {
  return await api.post<DefaultCouponCodeResponse>('payment/stripe/get_discount', { code: coupon });
};

export const updateDefaultCouponCode = async (coupon: string): Promise<DiscoveryDoneResponse> => {
  return await api.post<DiscoveryDoneResponse>('signup/funnel/step', { couponCode: coupon });
};

export const makeMockPayment = async (): Promise<any> => {
  return await api.post<any>('payment/add-mock-payment', {});
};

export const getPaywallMetadata = async (variant?: string): Promise<PaywallMeta> => {
  return await api.get<PaywallMeta>('onboarding/web/paywall-meta', { variant });
};

export const createPaymentEntity = async (params: CreatePaymentEntityParams): Promise<CreatePaymentEntityResponse> => {
  return await api.post<CreatePaymentEntityResponse>('payment/stripe/payment-entity', params);
};

export const canUserMakePayment = async (): Promise<void> => {
  return await api.get<void>('payment/stripe/can-make-payment');
};

export const finalizePaymentAfterRedirection = async (params: FinalizePaymentAfterRedirectionParams): Promise<void> => {
  return await api.post<void>('payment/stripe/finalize-payment-after-redirection', params);
};
